var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"canvas-box"},[_c('div',{ref:"canvas",staticClass:"canvas",style:(_vm.canvasStyle)},_vm._l((_vm.$store.state.items),function(item){return _c(item.type,{key:item.id,tag:"component",attrs:{"id":item.id,"content":item.content},on:{"input":function($event){return _vm.onInput(item, $event)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }